// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import useApiRequest from '../useRequest';
import { useQueryTenant } from '../useQueryRequest';
import t from './types';

// Common invalidate queries.
const commonInvalidateQueries = (queryClient) => {
  // Invalidate vendors.
  queryClient.invalidateQueries(t.VENDORS);
  // Invalidate customers.
  queryClient.invalidateQueries(t.CUSTOMERS);
};

/**
 * Retrieve the contact duplicate.
 */
export function useContact(id, props) {
  const apiRequest = useApiRequest();

  return useQueryTenant(
    ['CONTACT', id],
    () => apiRequest.get(`contacts/${id}`),
    {
      select: (res) => res.data.customer,
      ...props,
    },
  );
}

/**
 * Retrieve the auto-complete contacts.
 */
export function useAutoCompleteContacts(query = {}, props = {}) {
  const apiRequest = useApiRequest();

  return useQueryTenant(
    ['CONTACTS', 'AUTO-COMPLETE', query],
    () => apiRequest.get('contacts/auto-complete', { params: query }),
    {
      select: (res) => res.data.contacts,
      defaultData: [],
      ...props,
    },
  );
}

/**
 * Retrieve the auto-complete contacts with search functionality.
 * This hook is designed for suggest fields that need server-side search.
 */
export function useSearchableContacts(keyword = '', props = {}) {
  const apiRequest = useApiRequest();

  return useQueryTenant(
    ['CONTACTS', 'AUTO-COMPLETE', 'SEARCH', keyword],
    () => apiRequest.get('contacts/auto-complete', {
      params: {
        keyword: keyword || undefined,
        limit: 20 // Increase limit for search results
      }
    }),
    {
      select: (res) => res.data.contacts,
      defaultData: [],
      enabled: true, // Always enabled, but will return all contacts when keyword is empty
      ...props,
    },
  );
}

/**
 * Activate the given Contact.
 */
export function useActivateContact(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((id) => apiRequest.post(`contacts/${id}/activate`), {
    onSuccess: (res, id) => {
      // Invalidate specific contact.
      queryClient.invalidateQueries([t.CONTACT, id]);

      // Common invalidate queries.
      commonInvalidateQueries(queryClient);
    },
    ...props,
  });
}

/**
 * Inactivate the given contact.
 */
export function useInactivateContact(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((id) => apiRequest.post(`contacts/${id}/inactivate`), {
    onSuccess: (res, id) => {
      // Invalidate specific item.
      queryClient.invalidateQueries([t.CONTACT, id]);

      // Common invalidate queries.
      commonInvalidateQueries(queryClient);
    },
    ...props,
  });
}
